import {
  AdminSpinner,
  Box,
  CustomersOverviewEntity,
  Div,
  formatNumber,
  getDashboardCustomerOverview,
  H3,
  H5,
  Icon,
  lightTheme,
  LogoWhiteCircle,
  P,
  Separator,
  VerticalSeparator,
  reportError,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { GraphWrapper } from '../../DashboardStyled';
import { dataCustomers } from '../../dummyData';

async function getBestPerformingCustomers(
  setCustomersOverview: Dispatch<
    SetStateAction<CustomersOverviewEntity | null>
  >,
  setLoading: Dispatch<SetStateAction<boolean>>
) {
  setLoading(true);

  try {
    const { data } = await getDashboardCustomerOverview();

    setCustomersOverview(data.data);
  } catch (error) {
    reportError(error);
  } finally {
    setLoading(false);
  }
}

export const BestPerformingCustomersSection = () => {
  const [loading, setLoading] = useState(false);
  const [customersOverview, setCustomersOverview] =
    useState<CustomersOverviewEntity | null>(null);

  useEffect(() => {
    getBestPerformingCustomers(setCustomersOverview, setLoading);
  }, []);

  return (
    <Box $p="16px 20px" $relative>
      {loading && <AdminSpinner small absolute creme />}

      <H5 $mb="16">Customers Overview</H5>

      <Div $flex $alignCenter>
        <Div $width="40%">
          <Div>
            <P $m="0" $bold>
              New Customers
            </P>
            <Div $flex $alignCenter $columnSM $alignStartSM>
              <H3 $color={lightTheme.blue} $m="0">
                {formatNumber(customersOverview?.newCustomers || 0)}
              </H3>
              <Div $desktop>
                <VerticalSeparator
                  $w="2px"
                  $color={lightTheme.lightGray}
                  $h="20px"
                  $m="10px"
                />
              </Div>
              <Div $mobile>
                <Separator
                  $w="20px"
                  $color={lightTheme.lightGray}
                  // $h="2px"
                  $m="5px 0"
                />
              </Div>
              <H5 $color={lightTheme.blue} $m="0">
                {formatNumber(customersOverview?.newCustomersPercentage || 0)}%
              </H5>
            </Div>
          </Div>

          <Separator $m="10px 0" />

          <Div>
            <P $m="0" $bold>
              Returning Customers
            </P>
            <Div $flex $alignCenter $columnSM $alignStartSM>
              <H3 $color={lightTheme.green} $m="0">
                {formatNumber(customersOverview?.returningCustomers || 0)}
              </H3>
              <Div $desktop>
                <VerticalSeparator
                  $w="2px"
                  $color={lightTheme.lightGray}
                  $h="20px"
                  $m="10px"
                />
              </Div>
              <Div $mobile>
                <Separator
                  $w="20px"
                  $color={lightTheme.lightGray}
                  // $h="2px"
                  $m="5px 0"
                />
              </Div>
              <H5 $color={lightTheme.green} $m="0">
                {customersOverview?.returningCustomersPercentage}%
              </H5>
            </Div>
          </Div>

          <Separator $m="10px 0" />

          <Div>
            <P $m="0" $bold>
              Total Customers
            </P>
            <Div $flex $alignCenter>
              <H3 $color={lightTheme.primary} $m="0">
                {formatNumber(customersOverview?.totalCustomers || 0)}
              </H3>
            </Div>
          </Div>
        </Div>

        {customersOverview && (
          <GraphWrapper style={{ position: 'relative' }}>
            <Icon
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
              $size={window.innerWidth < 800 ? 60 : 100}
            >
              <LogoWhiteCircle />
            </Icon>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart width={400} height={400}>
                <Pie
                  data={dataCustomers(customersOverview)}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  // label={renderCustomizedLabel}
                  outerRadius={window.innerWidth < 800 ? 80 : 120}
                  innerRadius={window.innerWidth < 800 ? 30 : 50}
                  fill="#000000"
                  dataKey="value"
                >
                  {dataCustomers(customersOverview).map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </GraphWrapper>
        )}
      </Div>
    </Box>
  );
};
